import { CONFIG as DEV_CONFIG_LOCAL } from './dev-local';
import { CONFIG as DEV_CONFIG } from './dev';
import { CONFIG as PREPROD_CONFIG } from './preprod';
import { CONFIG as UAT_CONFIG } from './uat';
import { CONFIG as HOTFIX_CONFIG } from './hotfix';
import { CONFIG as PROD_CONFIG } from './prod';
import { CONFIG as TEST_CONFIG } from './test';
import { IConfig } from 'configs/config.interface';

const environment = process.env.NODE_ENV;

const getEnvironment = (): IConfig => {
    if(environment === 'development') {
        return DEV_CONFIG;
    }
    if(environment === 'preprod') {
        return PREPROD_CONFIG;
    }
    if(environment === 'uat') {
        return UAT_CONFIG;
    }
    if(environment === 'hotfix') {
        return HOTFIX_CONFIG;
    }
    if(environment === 'production') {
        return PROD_CONFIG;
    }
    if(environment === 'test') {
        return TEST_CONFIG;
    }
    return DEV_CONFIG_LOCAL;
};

// RumInit({
//     app: {
//       name: RUM_Name,
//       version: '1.0.0',
//       environment: process.env.NODE_ENV
//     },
//     ignoreUrls: [`http://localhost:${process.env.PORT}/`],
//     apiKey: RUM_Key, // This is api key for dev
//     debug: true, // Shows the captured in console
//     traceLog: false // Sends Traces to Loki ( For easy querying of traces)
//   });

export const CONFIG: IConfig = getEnvironment();
